export const emailDomainBase = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'protonmail.com',
    'mail.com',
    'zoho.com',
    'live.com',
    'ymail.com',
    'rocketmail.com',
    'outlook.com',
    'gmx.com',
    'fastmail.com',
    'inbox.com',
    'yahoo.co.uk',
    'hotmail.co.uk',
    'me.com',
    'sbcglobal.net',
];
